module.exports = __webpack_public_path__ + "static/media/top_infographic_desktop.9ec73f1a.webp";